<template>
  <div class="main">
    <img src="../assets/bigbg.png" style="width: 100%;height: 100%;position: relative;"/>
<!--    <svg-icon icon-class="title" style="font-size:20vw;position: absolute;height: 4vw;right: 4vw;top: 3vw;z-index: 1001"/>-->
    <!--    <svg-icon icon-class="left" :style="{height:height+'px',width:468/900*height+'px'}" style="position: absolute;width: 468px;height:900px;left: 0px;top: 50%;transform: translateY(-50%)"/>-->
    <!--    <svg-icon icon-class="right" :style="{height:height+'px',width:806/900*height+'px'}" style="position: absolute;right: 0px;top: 50%;transform: translateY(-50%)"/>-->
<!--    <svg-icon icon-class="center"  :style="{height:361/900 * height+'px',width:800/900 * height }" style="position: absolute;left: 40%;top: 50%;transform: translate(-50%,-50%)"/>-->
<!--    <svg-icon icon-class="first1" :style="{height:76/900 * height+'px',width:500/900 * height }" style="position: absolute;left: 50%;bottom: 3vw;transform: translateX(-50%)"/>-->
    <div class="box" v-show="!isForget" >
      <div class="title">
        <span class="title-text" >
          账号登录
        </span>
      </div>
      <div :class="['input-box',inputStatus.name&&'input-error']">
        <!--        <img src="../assets/user.png" class="flag" />-->
        <svg-icon class="flag"  icon-class="user"/>
        <input v-model="loginInfo.name" placeholder="请输入工号" @input="inputStatus.name=false" class="input" @keydown.enter="doLogin"/>
      </div>
      <div :class="['input-box',inputStatus.pwd&&'input-error']" style="top: 18vh">
        <!--        <img src="../assets/pwd.png" class="flag"/>-->
        <svg-icon class="flag"  icon-class="pwd"/>
        <input type="password" v-model="loginInfo.pwd" placeholder="请输入密码" @input="inputStatus.pwd=false" class="input" @keydown.enter="doLogin"/>
      </div>
      <div class="operate-pwd">
        <!--        <img v-if="checked" @click="checked = !checked" src="../assets/checked.png" style="width: 0.9vw;cursor: pointer"/>-->
        <!--        <img v-else @click="checked = !checked" src="../assets/no-check.png" style="width: 0.9vw;cursor: pointer"/>-->
        <!--        <span style="margin-left: 0.3vw;font-size: 0.8vw;">记住密码</span>-->
        <span @click="isForget = true" class="edit-pwd" >修改密码</span>
      </div>
      <div class="login" @click="doLogin">
        <span>登录</span>
      </div>
      <div class="group" >
        <span>欢迎登录抚顺新钢铁有限责任公司内网</span>
      </div>
    </div>
    <div class="box" v-show="isForget" >
      <div class="title">
        <span class="title-text" >修改密码</span>
        <div class="btn" @click="isForget=false" >返回</div>
      </div>
      <div :class="['input-box',inputStatus.name&&'input-error']">
        <svg-icon class="flag"  icon-class="user"/>
        <!--        <img src="../assets/user.png" class="flag" />-->
        <input v-model="editInfo.name" placeholder="请输入工号" class="input" @input="inputStatus.name=false" @keydown.enter="doEdit"/>
      </div>
      <div :class="['input-box',inputStatus.oldPwd&&'input-error']" style="top: 18vh">
        <!--        <img src="../assets/pwd.png" class="flag"/>-->
        <svg-icon class="flag"  icon-class="pwd"/>
        <input type="password" v-model="editInfo.oldPwd" placeholder="请输入旧密码" class="input" @input="inputStatus.oldPwd=false"  @keydown.enter="doEdit"/>
      </div>
      <div :class="['input-box',inputStatus.newPwd&&'input-error']" style="top: 26vh">
        <!--        <img src="../assets/pwd.png" class="flag"/>-->
        <svg-icon class="flag"  icon-class="pwd"/>
        <input v-model="editInfo.newPwd" placeholder="请输入新密码" class="input" @input="inputStatus.newPwd=false"  @keydown.enter="doEdit"/>
      </div>
      <div class="login" style="top: 34vh;" @click="doEdit">
        <span>确认修改</span>
      </div>
    </div>
  </div>
</template>

<script>
import {throttle} from "../util"
export default {
  name: 'HelloWorld',
  data(){
    return {
      height:0,
      isLogin:false,
      isEdit:false,
      checked:false,
      isForget:false,
      inputStatus:{
        name:false,
        pwd:false,
        oldPwd:false,
        newPwd:false
      },
      loginInfo:{
        name:'',
        pwd:''
      },
      editInfo:{
        name:'',
        oldPwd:'',
        newPwd:''
      },
      referrer:'',
    }
  },
  props: {
    msg: String
  },
  methods:{
    doLogin:throttle(function(){
      let isNo = false
      if(!this.loginInfo.name){
        isNo = this.inputStatus.name = true
      }
      if(!this.loginInfo.pwd){
        isNo = this.inputStatus.pwd = true
      }
      if(!isNo){
        this.$http.get("/sso/doLogin",{
          params: {
            userName: this.loginInfo.name,
            password: this.loginInfo.pwd
          },
        }).then(msg=>{
          this.$message.success(msg)
          this.$http.get(`http://10.6.1.129/login/api/logintime.php?username=${this.loginInfo.name}`)
          setTimeout(function() {
            location.reload();
          }, 800)
        }).catch(err=>{
          this.$message.error(err)
        })
      }
    },1000),
    doEdit:throttle(function(){
      let isNo = false
      if(!this.editInfo.name){
        isNo = this.inputStatus.name = true
      }
      if(!this.editInfo.oldPwd){
        isNo = this.inputStatus.oldPwd = true
      }
      if(!this.editInfo.newPwd){
        isNo = this.inputStatus.newPwd = true
      }
      if(!isNo) {
        this.$http.post("/login/changePwd", {
          userName: this.editInfo.name,
          password: this.editInfo.oldPwd,
          newPwd: this.editInfo.newPwd,
        }).then(msg => {
          this.$message.success(msg)
          this.isForget = false
          this.loginInfo = {
            name:this.editInfo.name,
            pwd:''
          }
          this.editInfo = {
            name: '',
            oldPwd: '',
            newPwd: ''
          }
        }).catch(err => {
          this.$message.error(err)
          this.editInfo.oldPwd = ""
        })
      }
    },1000)
  },
  mounted() {
    this.height = document.documentElement.clientHeight
  },
  created() {
    this.referrer = document.referrer
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >
input{
  padding: 0;
}
input::placeholder{
  color: #999999;
}
/* 设置未选中样式 */
input[type="checkbox"] {
  position: relative;
  width: 0.9vw;
  height:0.9vw;
  border: 0.1vw solid #949494;

  /* 取消默认样式 */
  -webkit-appearance: none;
}
/* 设置选中样式 */
input[type="checkbox"]:checked {
  background-color: red;
}
input[type="checkbox"]:checked::after {
  content: "✓";
  position: absolute;
  top: 0;
  width:0.9vw;
  height:0.9vw;
  color: #fff;
  text-align: center;
}
input[type="checkbox" i] {
  margin: 0;
}
.main{
  position: absolute;
  bottom: 0;
  top:0;
  left: 0;
  right: 0;
  overflow: hidden;
}
.box{
  position: absolute;
  z-index: 9999;
  top: 30%;
  right: 10%;
  width: 22.1vw;
  height: 43vh;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1vw 1vw  rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  border-radius: 1vw;
}
.title{
  position: absolute;
  display: flex;
  align-items: center;
  top: 3vh;
  left: 1.4vw;
  width: 19.3vw;
  height: 5vh;
}
.title-text{
  font-size: 1.5vw;
  color:#3370FF;
  font-weight: 500
}
.input-box{
  position: absolute;
  top: 10vh;
  left: 1.4vw;
  width: 19.3vw;
  height: 5vh;
  background: rgba(233, 238, 245, 1);
  display: flex;
  align-items: center;
  box-sizing: border-box;
}
.input-error{
  border:0.1vw solid #FC5A5A;
}
.flag{
  font-size: 1vw;
  margin-left: 0.7vw;
  fill:#3370FF !important;
}
.edit-pwd{
  margin-left: auto;
  color: #3370FF;
  font-size: 0.8vw;
  font-weight: 500;
  cursor: pointer
}
.input{
  font-size: 1vw;
  height: 4vh;
  width: 14vw;
  margin-left: 0.7vw;
  background: rgba(233, 238, 245, 1);
  border: none;
  outline: none;
}


.operate-pwd{
  position: absolute;
  left: 1.4vw;
  top: 25vh;
  width: 19.3vw;
  height: 5vh;
  display: flex;
  align-items: center;
}
.login{
  position: absolute;
  left: 1.4vw;
  top: 31vh;
  width: 19.3vw;
  height: 5vh;
  background: #3370FF;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  font-size: 1vw;
  cursor: pointer;
}
.group{
  position: absolute;
  left: 1.4vw;
  top: 36vh;
  width: 19.3vw;
  height: 5vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666666;
  font-size: 1vw;
}
.btn{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left:auto;
  background: #3370FF;
  height: 2.5vh;
  width: 3vw;
  color: #FFFFFF;
  font-size:0.7vw;
  border-radius: 0.4vw;
  cursor: pointer;
}
</style>

